import React from "react";
import { SpinnerDotted } from "spinners-react";
import { colors } from "../../config/color";

export type LoaderProps = {
  color?: string;
};

export const Loader: React.FC<LoaderProps> = ({ color = colors.color }) => {
  return <SpinnerDotted size={50} thickness={100} speed={100} color={color} />;
};
